import { Stack, Typography } from '@mui/material';
import { RegularConstraint } from 'features/co-pilot/co-pilot.types';
import PaiSearchSelector from 'features/ui/base-components/pai-search-selector';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import ConstraintChip from './constraint-chip';

interface Props {
  regularLocationConstraints: RegularConstraint;
  disabled?: boolean;

  handleLocationFieldChange(event: React.ChangeEvent<HTMLInputElement>): void;

  searchKeyUp(): void;

  searchKeyDown(): void;

  handleMultiSelectLocationsChange(value: string): () => void;

  handleMultiSelectLocationsRemove(value: string): () => void;
}

const Location: React.FC<Props> = ({
  regularLocationConstraints,
  disabled,
  handleLocationFieldChange,
  searchKeyUp,
  searchKeyDown,
  handleMultiSelectLocationsChange,
  handleMultiSelectLocationsRemove,
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { query, options, selected, loading } = regularLocationConstraints;

  const locationOptions = useMemo(() => options.map((option) => ({ label: option[1], value: option[0] })), [options]);
  const selectedStrings = useMemo(() => selected.map((option) => option[0]), [selected]);
  const selectedObjects = useMemo(() => selected.map((option) => ({ label: option[1], value: option[0] })), [selected]);

  return (
    <Stack gap={1}>
      <PaiSearchSelector
        placeholder={t('enterLocationHere')}
        value={query}
        selectedValues={selectedStrings}
        options={locationOptions}
        onChange={handleLocationFieldChange}
        onKeyUp={searchKeyUp}
        onKeyDown={searchKeyDown}
        onMenuItemClick={handleMultiSelectLocationsChange}
        multiselect={true}
        style={{ maxWidth: '600px' }}
        disabled={disabled || loading}
        loading={loading}
      />
      {regularLocationConstraints.isEmpty ? <Typography className={classes.errorText}>{t('noLocationsFound')}</Typography> : null}
      {!_.isEmpty(selected) ? (
        <Stack direction={'row'} gap={1} flexWrap={'wrap'} sx={{ maxWidth: '700px' }}>
          {selectedObjects.map((item) => (
            <ConstraintChip key={item.value} label={item.label} handleRemoveRecruiterConstraint={handleMultiSelectLocationsRemove(item.value)} />
          ))}
        </Stack>
      ) : null}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  errorText: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.error.main,
    padding: '0 8px',
  },
}));

export default Location;
